import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "./pages/Login/login";
import Home from "./pages/Home/Home";
import CreateUser from "./pages/createUser/CreateUser";
import Photos from "./pages/Photos/Photos";
import MoreDents from "./pages/MoreDents/MoreDents";
import Location from "./pages/Location/Location";
import Time from "./pages/Time/Time";
import Car_info from "./pages/Car_info/Car_info";
import Finding_a_Denter from "./pages/Finding_a_Denter/Finding_a_Denter";
import Qualification from "./pages/Status_job/Qualification";
import In_progress from "./pages/In_progress/In_progress";
import Estimation_proposal from "./pages/Estimation_proposal/Estimation_proposal";
import Payment from "./pages/Payment/Payment";
import Login_technician from "./Technician/pages/Login/Login_Technician";
import CreateNewAccount from "./Technician/pages/CreateNewAccount/CreateNewAccount";
import CancelJob from "./Technician/pages/CancelJob/CancelJob";
import HomeTechnician from "./Technician/pages/Home/HomeTechnician";
import Profile from "./Technician/pages/Profile/Profile";
import AccountSettings from "./Technician/pages/AccountSettings/AccountSettings";
import Job_in_progress from "./Technician/pages/Job_in_progress/Job_in_progress";
import Waiting_for_customer from "./Technician/pages/WaitingForCustomer/Waiting_for_customer";
import Job_completed from "./Technician/pages/Job_completed/Job_completed";
import Job_canceled from "./Technician/pages/Job_canceled/Job_canceled";
import Request_available from "./Technician/pages/Request_available/Request_available";
import Confirm from "./Technician/pages/Confirm/Confirm";
import View_profile from "./pages/ProfileConsumer/View_profile.js";
import Settings from "./pages/Settings/Settings";
import Admin from "./Admin/Admin";
import Dashboard from "./Admin/Dashboard";
import DentSelected from "./Admin/DentSelected";
import New_time from "./pages/Time/New_time";
import AppHome from "./pages/AppHome";
import Home_admin from './Admin/Home_admin'
import Price_estimate from "./pages/Price_estimate/Price_estimate";
import Time_confirmation from "./pages/Time_confirmation/Time_confirmation"
import Dent_information from "./Admin/Dent_information";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={AppHome} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/CreateUser" component={CreateUser} />
        <Route exact path="/Home" component={Home} />
        <Route exact path="/Photos" component={Photos} />
        <Route exact path="/MoreDents" component={MoreDents} />
        <Route exact path="/Location" component={Location} />
        <Route exact path="/Time" component={Time} />
        <Route exact path="/finding_a_denter" component={Finding_a_Denter} />
        <Route exact path="/qualification" component={Qualification} />
        <Route exact path="/in_progress" component={In_progress} />
        <Route
          exact
          path="/estimation_proposal"
          component={Estimation_proposal}
        />
        <Route exact path="/payment" component={Payment} />
        <Route exact path="/car_info" component={Car_info} />
        <Route exact path="/login_Technician" component={Login_technician} />
        <Route exact path="/CreateNewAccount" component={CreateNewAccount} />
        <Route exact path="/cancelJob" component={CancelJob} />
        <Route exact path="/homeTechnician" component={HomeTechnician} />
        <Route exact path="/profile" component={Profile} />
        <Route exact path="/accountSettings" component={AccountSettings} />
        <Route exact path="/job_in_progress" component={Job_in_progress} />
        <Route
          exact
          path="/waiting_for_customer"
          component={Waiting_for_customer}
        />
        <Route exact path="/job_completed" component={Job_completed} />
        <Route exact path="/job_canceled" component={Job_canceled} />
        <Route exact path="/request_available" component={Request_available} />
        <Route exact path="/confirm" component={Confirm} />
        <Route exact path="/view_profile" component={View_profile} />
        <Route exact path="/settings" component={Settings} />
        <Route exact path="/admin" component={Admin} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/dentSelected" component={DentSelected} />
        <Route exact path="/new_time" component={New_time} />
        <Route exact path="/home_admin" component={Home_admin} />
        <Route exact path="/price_estimate" component={Price_estimate} />
        <Route exact path="/time_confirmation" component={Time_confirmation} />
        <Route exact path="/dent_information" component={Dent_information} />

      </Switch>
    </BrowserRouter>
  );
}

export default App;
